// src/pages/resources/AdminUsers.js
import React from "react";
import {
  Resource,
  List,
  Datagrid,
  TextField,
  BooleanField,
  ArrayField,
  DateField,
  FunctionField,
  TextInput,
  Pagination,
  Filter,
  TopToolbar,
  ExportButton,
  ShowButton,
  Show,
  SimpleShowLayout,
  BooleanInput,
  useNotify,
  useRefresh,
  Button,
} from "react-admin";
import SyncIcon from "@mui/icons-material/Sync";
const syncUrl = `${process.env.REACT_APP_API_URL}/admin_sync_stripe_users`;

const ListActions = () => {
  const notify = useNotify();
  const refresh = useRefresh();

  const handleSync = async () => {
    try {
      notify("Syncing Stripe users... Please wait.", { type: "info" });

      const token = localStorage.getItem("jwtToken");
      const res = await fetch(syncUrl, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      const data = await res.json();
      if (res.ok && !data.error) {
        notify(`✅ ${data.msg}`, { type: "success" });
      } else {
        notify(`❌ ${data.msg || "Failed to sync users"}`, { type: "warning" });
      }
      refresh();
    } catch (error) {
      console.error("Sync error:", error);
      notify("❌ Error syncing Stripe users", { type: "error" });
    }
  };

  return (
    <TopToolbar>
      <Button
        label="Sync Stripe Users"
        onClick={handleSync}
        startIcon={<SyncIcon />}
      />
      <ExportButton />
    </TopToolbar>
  );
};

const UserFilter = (props) => (
  <Filter {...props}>
    <TextInput source="q" label="Search" alwaysOn />
    <TextInput source="username" label="Username" alwaysOn />
    <TextInput source="email" label="Email" alwaysOn />
    <BooleanInput source="is_premium" label="Premium Only" alwaysOn />
  </Filter>
);

export const UserList = (props) => (
  <List
    {...props}
    filters={<UserFilter />}
    perPage={25}
    actions={<ListActions />}
    pagination={<Pagination rowsPerPageOptions={[10, 25, 50]} />}
  >
    <Datagrid rowClick={false} bulkActionButtons={false}>
      <TextField source="full_name" />
      <TextField source="email" />
      <TextField source="phone" />
      <TextField source="address" />
      <BooleanField source="is_premium" />
      <FunctionField
        label="Latest expiry"
        render={(record) => {
          if (!record.subscriptions?.length) return null;
          const latest = record.subscriptions.reduce((acc, s) => {
            const cand =
              s.expiry_date ||
              s.current_period_end ||
              s.expiry ||
              s.purchase_date;
            if (!cand) return acc;
            const candDate = new Date(cand);
            return !acc || candDate > acc ? candDate : acc;
          }, null);
          return latest ? new Date(latest).toLocaleString() : null;
        }}
      />
      <ShowButton />
    </Datagrid>
  </List>
);

export const UserShow = (props) => (
  <Show {...props}>
    <SimpleShowLayout>
      <TextField source="id" />
      <TextField source="username" />
      <TextField source="email" />
      <TextField source="full_name" />
      <TextField source="phone" />
      <TextField source="address" />
      <BooleanField source="is_premium" />
      {/*       <TextField source="stripe_customer_id" />
      <TextField source="stripe_subscription_id" />
 */}{" "}
      <ArrayField source="subscriptions">
        <Datagrid bulkActionButtons={false}>
          <TextField source="plan_name" />
          <DateField source="expiry_date" />
          <TextField source="price" />
          {/* <DateField source="purchase_date" /> */}
        </Datagrid>
      </ArrayField>
    </SimpleShowLayout>
  </Show>
);

export const UserResource = (
  <Resource
    name="users"
    list={UserList}
    show={UserShow}
    hasShow
    options={{ label: "Users" }}
  />
);
